import { ReactElement } from 'react';
import { MenuItem, styled } from '@mui/material';
import { StyledSelect, ValueLabel } from '../common';
import { csaStatusOption, byLabel, statusOptionRa, statusOptionDi } from '.';
import { pathOr, equals } from 'rambda';
import { map, sortBy as fSortBy } from 'fp-ts/Array';
import { flow } from 'fp-ts/function';

export const labelP1 = {
  createdAt: 'Start Date:',
  updateDatetime: 'Start Date:',
  deaRetdt: 'Start Date:',
  status: 'Select Status:',
  deaNumbers: 'Enter Value:',
  requestId: 'Enter Value:',
  reqType: 'Enter Value:',
  requestorEmail: 'Enter Value:',
  sailpointCaseId: 'Enter Value:',
};

export const labelP2 = {
  createdAt: 'End Date:',
  updateDatetime: 'End Date:',
  deaRetdt: 'End Date:',
};

export const enableP2 = (a: string) =>
  equals('createdAt')(a) ||
  equals('updateDatetime')(a) ||
  equals('deaRetdt')(a);

export const renderP2 = ({
  searchP2,
  setSearchP2,
}: {
  searchP2: string;
  setSearchP2: (a: string) => void;
}) => (
  <Input
    aria-labelledby="search-parameter-2"
    value={searchP2}
    onChange={flow(pathOr('', 'target.value'), setSearchP2)}
    type="date"
    style={{ justifySelf: 'stretch' }}
  />
);

export const renderP1 = ({
  di,
  csa,
  searchBy,
  searchP1,
  setSearchP1,
}: {
  di: boolean;
  csa: boolean;
  searchBy: string;
  searchP1: string;
  setSearchP1: (a: string) => void;
}) =>
  enableP2(searchBy) ? (
    <Input
      aria-labelledby="search-parameter-1"
      value={searchP1}
      onChange={flow(pathOr('', 'target.value'), setSearchP1)}
      type="date"
      style={{ justifySelf: 'stretch' }}
    />
  ) : searchBy === 'status' ? (
    <StyledSelect
      aria-labelledby="search-parameter-1"
      value={searchP1}
      onChange={flow(pathOr('', 'target.value'), setSearchP1)}
      variant="outlined"
      style={{ justifySelf: 'stretch' }}>
      {flow(
        fSortBy([byLabel]),
        map<ValueLabel<string>, ReactElement>(({ value, label }) => (
          <MenuItem value={value}>{label}</MenuItem>
        ))
      )(di ? (csa ? csaStatusOption : statusOptionDi) : (csa ? csaStatusOption : statusOptionRa))}
      {/* )(csa ? csaStatusOption : statusOption)} */}
    </StyledSelect>
  ) : (
    <Input
      aria-labelledby="search-parameter-1"
      aria-describedby="search-parameter-help"
      value={searchP1}
      onChange={flow(pathOr('', 'target.value'), setSearchP1)}
      type="text"
      style={{ justifySelf: 'stretch' }}
    />
  );

const Input = styled('input')(({ theme }) => ({}));
